import getWESchema from './getWESchema';
import getEducationSchema from './getEducationSchema';
import getSkillSchema from './getSkill';
import getAwardsAndHonors from './getAwardsAndHonors';
import getVolunteerWork from './getVolunteerWork';
import getProjects from './getProjects';
import getLeadership from './getLeadership';
import getAssociations from './getAssociations';
import getCertifications from './getCertifications';
import getInput from './getInput';
import getCourses from './getCourses';
import getConferences from './getConferences';
import getReferences from './getReferences';
import getPatents from './getPatents';
import getTestScores from './getTestScores';
import getDate from './getDate';
import getSummarySchema from './getSummarySchema';
import getECSchema from './getECSchema';
import getResearchSchema from './getResearchSchema';

export default {
  fullName: getInput({ preTag: 'full_name' }),
  tagline: getInput({ preTag: 'tagline' }),
  phoneNumber: getInput({ preTag: 'phone_number' }),
  email: getInput({ preTag: 'email' }),
  address: getInput({ preTag: 'address' }),
  objective: getInput({ preTag: 'objective' }),
  workExperience: getWESchema({ preTag: 'work_experience' }),
  education: getEducationSchema({ preTag: 'education' }),
  skills: getSkillSchema({ preTag: 'skill' }),
  awardsAndHonors: getAwardsAndHonors({ preTag: 'awards_and_honors' }),
  courses: getCourses({ preTag: 'courses' }),
  conferences: getConferences({ preTag: 'conferences' }),
  references: getReferences({ preTag: 'references' }),
  patents: getPatents({ preTag: 'patents' }),
  testScores: getTestScores({ preTag: 'test_scores' }),
  volunteerWork: getVolunteerWork({ preTag: 'volunteer_work' }),
  certifications: getCertifications({ preTag: 'certifications' }),
  projects: getProjects({ preTag: 'projects' }),
  researchExperience: getResearchSchema({ preTag: 'research_experience' }),
  leadership: getLeadership({ preTag: 'leadership' }),
  associations: getAssociations({ preTag: 'associations' }),
  extraCurricular: getECSchema({ preTag: 'extra_curricular' }),
  languages: getSkillSchema({ preTag: 'language' }),
  hobbiesAndInterests: getSkillSchema({
    preTag: 'hobbies_and_interests',
  }),
  personalLinks: getSkillSchema({ preTag: 'personal_link' }),
  publications: getSkillSchema({ preTag: 'publication' }),

  senderName: getInput({ preTag: 'sender_name' }),
  senderTagline: getInput({
    preTag: 'sender_tagline',
  }),
  senderPhoneNumber: getInput({
    preTag: 'sender_phone_number',
  }),
  senderAddress: getInput({
    preTag: 'sender_address',
  }),
  senderEmail: getInput({
    preTag: 'sender_email',
  }),
  receiverName: getInput({
    preTag: 'receiver_name',
  }),
  receiverTagline: getInput({
    preTag: 'receiver_tagline',
  }),
  receiverOrganization: getInput({
    preTag: 'receiver_organization',
  }),
  receiverAddress: getInput({
    preTag: 'receiver_address',
  }),
  letterDate: getDate({ preTag: 'letter_date' }),
  letterBody: getSummarySchema({ preTag: 'letter_body' }),
  subjectLine: getInput({
    preTag: 'subject_line',
  }),
  openGreeting: getInput({
    preTag: 'open_greeting',
  }),
  closeGreeting: getInput({
    preTag: 'close_greeting',
  }),
  summary: getSummarySchema({ preTag: 'summary' }),
};
